import React from 'react';

const OrderStatus = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#A4A4A4"
        d="M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2zm0 14a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm0-10a3.999 3.999 0 0 0-3.973 3.542A.741.741 0 0 0 8 9.74v.518c0 .41.332.741.74.741h.52a.74.74 0 0 0 .74-.74V10a2 2 0 1 1 2 2h-.26a.74.74 0 0 0-.74.74v1.52c0 .408.332.74.74.74h.52a.74.74 0 0 0 .74-.74v-.386A4.002 4.002 0 0 0 12 6z"
      />
    </g>
  </svg>
);

export default OrderStatus;
